import {
  targetGroupsByRegionConstants,
  createTargetGroupsByRegionConstants,
  editTargetGroupsByRegionConstants,
  addTargetGroupsByRegionConstants,
  removeTargetGroupsByRegionConstants,
  deleteTargetGroupsByRegionConstants,
} from "../_redux-constants";

export function targetGroupsRegionReducer(
  state = {
    targetGroupsByRegionLoading: false,
    targetGroupsByRegionData: null,
    targetGroupsByRegionError: null,

    createTargetGroupsByRegionLoading: false,
    createTargetGroupsByRegionData: null,
    createTargetGroupsByRegionError: null,

    editTargetGroupsByRegionLoading: false,
    editTargetGroupsByRegionData: null,
    editTargetGroupsByRegionError: null,

    addTargetGroupsByRegionLoading: false,
    addTargetGroupsByRegionData: null,
    addTargetGroupsByRegionError: null,

    removeTargetGroupsByRegionLoading: false,
    removeTargetGroupsByRegionData: null,
    removeTargetGroupsByRegionError: null,

    deleteTargetGroupsByRegionLoading: false,
    deleteTargetGroupsByRegionData: null,
    deleteTargetGroupsByRegionError: null,
  },
  action
) {
  switch (action.type) {
    case targetGroupsByRegionConstants.TARGET_GROUPS_BY_REGION_LOADING:
      return Object.assign({}, state, {
        targetGroupsByRegionLoading: true,
        targetGroupsByRegionData: null,
        targetGroupsByRegionError: null,
      });
    case targetGroupsByRegionConstants.TARGET_GROUPS_BY_REGION_SUCCESS:
      return Object.assign({}, state, {
        targetGroupsByRegionLoading: false,
        targetGroupsByRegionData: action.data,
      });
    case targetGroupsByRegionConstants.TARGET_GROUPS_BY_REGION_FAILURE:
      return Object.assign({}, state, {
        targetGroupsByRegionLoading: false,
        targetGroupsByRegionData: null,
        targetGroupsByRegionError: action.error,
      });
    case createTargetGroupsByRegionConstants.CREATE_TARGET_GROUPS_BY_REGION_LOADING:
      return Object.assign({}, state, {
        createTargetGroupsByRegionLoading: true,
        createTargetGroupsByRegionData: null,
        createTargetGroupsByRegionError: null,
      });
    case createTargetGroupsByRegionConstants.CREATE_TARGET_GROUPS_BY_REGION_SUCCESS:
      return Object.assign({}, state, {
        createTargetGroupsByRegionLoading: false,
        createTargetGroupsByRegionData: action.data,
      });
    case createTargetGroupsByRegionConstants.CREATE_TARGET_GROUPS_BY_REGION_FAILURE:
      return Object.assign({}, state, {
        createTargetGroupsByRegionLoading: false,
        createTargetGroupsByRegionData: null,
        createTargetGroupsByRegionError: action.error,
      });
    case editTargetGroupsByRegionConstants.EDIT_TARGET_GROUPS_BY_REGION_LOADING:
      return Object.assign({}, state, {
        editTargetGroupsByRegionLoading: true,
        editTargetGroupsByRegionData: null,
        editTargetGroupsByRegionError: null,
      });
    case editTargetGroupsByRegionConstants.EDIT_TARGET_GROUPS_BY_REGION_SUCCESS:
      return Object.assign({}, state, {
        editTargetGroupsByRegionLoading: false,
        editTargetGroupsByRegionData: action.data,
      });
    case editTargetGroupsByRegionConstants.EDIT_TARGET_GROUPS_BY_REGION_FAILURE:
      return Object.assign({}, state, {
        editTargetGroupsByRegionLoading: false,
        editTargetGroupsByRegionData: null,
        editTargetGroupsByRegionError: action.error,
      });
    case addTargetGroupsByRegionConstants.ADD_TARGET_GROUPS_BY_REGION_LOADING:
      return Object.assign({}, state, {
        addTargetGroupsByRegionLoading: true,
        addTargetGroupsByRegionData: null,
        addTargetGroupsByRegionError: null,
      });
    case addTargetGroupsByRegionConstants.ADD_TARGET_GROUPS_BY_REGION_SUCCESS:
      return Object.assign({}, state, {
        addTargetGroupsByRegionLoading: false,
        addTargetGroupsByRegionData: action.data,
      });
    case addTargetGroupsByRegionConstants.ADD_TARGET_GROUPS_BY_REGION_FAILURE:
      return Object.assign({}, state, {
        addTargetGroupsByRegionLoading: false,
        addTargetGroupsByRegionData: null,
        addTargetGroupsByRegionError: action.error,
      });
    case removeTargetGroupsByRegionConstants.REMOVE_TARGET_GROUPS_BY_REGION_LOADING:
      return Object.assign({}, state, {
        removeTargetGroupsByRegionLoading: true,
        removeTargetGroupsByRegionData: null,
        removeTargetGroupsByRegionError: null,
      });
    case removeTargetGroupsByRegionConstants.REMOVE_TARGET_GROUPS_BY_REGION_SUCCESS:
      return Object.assign({}, state, {
        removeTargetGroupsByRegionLoading: false,
        removeTargetGroupsByRegionData: action.data,
      });
    case removeTargetGroupsByRegionConstants.REMOVE_TARGET_GROUPS_BY_REGION_FAILURE:
      return Object.assign({}, state, {
        removeTargetGroupsByRegionLoading: false,
        removeTargetGroupsByRegionData: null,
        removeTargetGroupsByRegionError: action.error,
      });
    case deleteTargetGroupsByRegionConstants.DELETE_TARGET_GROUPS_BY_REGION_LOADING:
      return Object.assign({}, state, {
        deleteTargetGroupsByRegionLoading: true,
        deleteTargetGroupsByRegionData: null,
        deleteTargetGroupsByRegionError: null,
      });
    case deleteTargetGroupsByRegionConstants.DELETE_TARGET_GROUPS_BY_REGION_SUCCESS:
      return Object.assign({}, state, {
        deleteTargetGroupsByRegionLoading: false,
        deleteTargetGroupsByRegionData: action.data,
      });
    case deleteTargetGroupsByRegionConstants.DELETE_TARGET_GROUPS_BY_REGION_FAILURE:
      return Object.assign({}, state, {
        deleteTargetGroupsByRegionLoading: false,
        deleteTargetGroupsByRegionData: null,
        deleteTargetGroupsByRegionError: action.error,
      });
    default:
      return state;
  }
}
